import { isString } from '@yescapa-dev/ysc-api-js/modern'
import type { Routing } from '@yescapa-dev/ysc-api-js/legacy'
import { RULES } from '~/constants/redirectedPath'
import type { LocaleRules, ManualRoutingRule, ReferentialRoutingRule } from '~/constants/redirectedPath'
import type { AvailableLocaleCodes } from '~/utils/types'

export function useGetRedirectedPath() {
  const {
    public: { djangoUrl },
  } = useRuntimeConfig()
  const { localeProperties: { yscCode } } = useLocaleProperties()
  const { routing } = useRoutingStore()

  function isKeyOfRouting(key: string): key is keyof Routing {
    return !!routing && key in routing
  }

  function isKeyOfRules(key: string, rules: LocaleRules): key is keyof typeof rules {
    return key in rules
  }

  // Get a path from home made dictionary or from routing
  const getPathFromRule = (rule?: ManualRoutingRule | ReferentialRoutingRule) => {
    if (!rule) {
      return undefined
    }
    if ('to' in rule) {
      return `${djangoUrl}${rule.to}`
    }

    const { routingKey } = rule
    if (!!routing && isKeyOfRouting(routingKey)) {
      const path = routing[routingKey]
      if (isString(path)) {
        return path
      }
    }
    return undefined
  }

  const getRedirectedPath = ({ routeName }: { routeName: MaybeRefOrGetter<string> }) => {
    let path: string | undefined = undefined
    const slugValue = toValue(routeName)
    const localeCode = yscCode as AvailableLocaleCodes
    const topLevelLocaleCode = getTopLevelLocale(localeCode)
    const localeRules = RULES[localeCode]
    const topLevelLocaleRules = topLevelLocaleCode !== 'pt' ? RULES[topLevelLocaleCode] : undefined

    // Try specific locale first
    if (!!localeRules && isKeyOfRules(slugValue, localeRules)) {
      path = getPathFromRule(localeRules[slugValue])
    }

    // Try topLevel then
    if (!path && !!topLevelLocaleRules && isKeyOfRules(slugValue, topLevelLocaleRules)) {
      path = getPathFromRule(topLevelLocaleRules[slugValue])
    }

    return path
  }
  return { getRedirectedPath }
}
